import React from 'react';
import Script from 'next/script';
import { useRouter } from 'next/router';
import { Flex } from '@components/common';
import { Heading } from '@components/typography';

const ScriptContent = () => {
	const { locale } = useRouter();
	const brandIds = {
		'en-US': 's3JNC4L4SjaYjdH4d2fd5Q',
		'en-CA': 'HGEbWDSQT5GK5a_kFkG6jw',
		'en-GB': '70M5gHbcTiGMbQMSMpi71A',
		'en-AU': '2POtrS2FQo-rep6pAGXymA',
	};
	const brandId = brandIds[locale] || brandIds['en-US'];
	return (
		<>
			<Flex align='center' justify='center' pad={4}>
				<Heading>Help Center</Heading>
			</Flex>
			<div id='gladly-help-center'></div>
			<Script id='glady' type='text/javascript'>
				{`window.gladlyHCConfig = { api: 'https://paireyewear.us-uat.gladly.qa', orgId: 'cVpcqvpCQS6sI1RoG0o3tg', brandId: '${brandId}', cdn: 'https://cdn.gladly.qa', selector: '#gladly-help-center' };`}
			</Script>
			<Script id='glady-funct' type='text/javascript'>
				{`(function() {
				var t = document,
				e = t.createElement('script');
				(e.type = 'text/javascript'), (e.async = !0), (e.src = 'https://cdn.gladly.com/help-center/hcl.js');
				var a = t.getElementsByTagName('script')[0];
				a.parentNode.insertBefore(e, a);
				}())`}
			</Script>
		</>
	);
};

export default ScriptContent;
